var debugStyle = function debugStyle(_ref) {
  var name = _ref.name,
      color = _ref.color,
      style = _ref.style;
  return {
    position: 'relative',
    border: "2px " + style + " " + color,
    '::before': {
      content: "'" + name + "'",
      position: 'absolute',
      padding: '1px 4px 1px',
      top: '-2px',
      left: '-2px',
      fontSize: '8px',
      fontWeight: 900,
      lineHeight: 1,
      letterSpacing: '1px',
      color: '#fff',
      background: color
    }
  };
};

export var debugRoot = function debugRoot() {
  return Object.assign({}, debugStyle({
    name: 'LAYOUT',
    color: 'cornflowerblue',
    style: 'solid'
  }), {
    padding: '8px',
    margin: '2px'
  });
};
export var debugArea = function debugArea() {
  return Object.assign({}, debugStyle({
    name: 'AREA',
    color: 'lightsalmon',
    style: 'dashed'
  }), {
    padding: '8px',
    margin: '2px'
  });
};
export var debugGap = function debugGap(_ref2) {
  var vertical = _ref2.vertical;
  return {
    display: 'grid',
    background: '#ccc',
    '::before': Object.assign({
      content: '"GAP"'
    }, vertical ? {
      letterSpacing: '1px'
    } : {
      textOrientation: 'upright',
      writingMode: 'vertical-rl'
    }, {
      alignSelf: 'center',
      justifySelf: 'center',
      fontSize: '8px',
      fontWeight: 900,
      lineHeight: 0,
      color: '#fff'
    })
  };
};
//# sourceMappingURL=debugStyles.js.map
